
export default function() {
  return [
    {
      title: "การประชุม",
      htmlBefore: '<i class="material-icons">create</i>',
      open: false,
      show: true,
      to: "/meeting",
    },
    {
      title: "จัดการข้อมูลอ้างอิง",
      htmlBefore: '<i class="material-icons">laptop</i>',
      htmlAfter: '<i class="material-icons mr-0">expand_more</i>',
      open: false,
      show: true,
      menus: [
        {
          title: "สถานที่ประชุม",
          to: "/location",
          show: true,
        },
        {
          title: "อาคารประชุม",
          to: "/building",
          show: true,
        },
        {
          title: "ห้องประชุม",
          to: "/room",
          show: true,
        },
        {
          title: "คำนำหน้าชื่อ",
          to: "/title",
          show: true,
        },
        {
          title: "ตำแหน่ง",
          to: "/position",
          show: true,
        },
        {
          title: "หน่วยงาน",
          to: "/department",
          show: true,
        },
        {
          title: "ตำแหน่งการประชุม",
          to: "/position_meeting",
          show: true,
        },
        {
          title: "กลุ่มผู้เข้าประชุม",
          to: "/group_name",
          show: true,
        }
      ]
    },
    {
      title: "ผู้ดูแลระบบ",
      htmlBefore: '<i class="material-icons">face</i>',
      htmlAfter: '<i class="material-icons mr-0">expand_more</i>',
      open: false,
      show: true,
      menus: [
        {
          title: "ข้อมูลผู้ใช้งาน",
          to: "/user",
          show: true,
        },
        {
          title: "กำหนด User Role",
          to: "/role",
          show: true,
        }
      ]
    },
  ];
}
